require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./zakladanie-spolek-zoo.json") })
        }
      }, "path---zakladanie-spolek-zoo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---zakladanie-spolek-zoo!./.cache/json/zakladanie-spolek-zoo.json
// module id = 526
// module chunks = 231608221292675